import { getPaymentModule } from './paymentModuleMap'

export const getActivePaymentModule = getPaymentModule

/** @deprecated 與 `getActivePaymentModule` 等價（B2B/B2C env 開關已移除），消費端收斂後刪除。 */
export const getActivePaymentModuleB2B = getActivePaymentModule

export type ActivePaymentModule = ReturnType<typeof getActivePaymentModule>
